<div class="footer">
  <div>{{STR_company}}</div>
</div>